import { combineReducers } from 'redux';
import passwordRestrictionSlice from './password/passwordRestrictionSlice';

export default combineReducers({
  password: passwordRestrictionSlice.reducer,
});
